import api from './api';

/**
 * Get all jobs with optional filters
 */
export const getJobs = async (params = {}) => {
  const response = await api.get('/jobs', { params });
  return response.data;
};

/**
 * Get job stats for dashboard
 */
export const getJobStats = async () => {
  const response = await api.get('/jobs/stats');
  return response.data;
};

/**
 * Get a single job
 */
export const getJob = async (id) => {
  const response = await api.get(`/jobs/${id}`);
  return response.data;
};

/**
 * Create a job manually
 */
export const createJob = async (data) => {
  const response = await api.post('/jobs', data);
  return response.data;
};

/**
 * Update a job
 */
export const updateJob = async (id, data) => {
  const response = await api.put(`/jobs/${id}`, data);
  return response.data;
};

/**
 * Delete a job
 */
export const deleteJob = async (id) => {
  const response = await api.delete(`/jobs/${id}`);
  return response.data;
};

/**
 * Re-extract job requirements
 */
export const extractJob = async (id) => {
  const response = await api.post(`/jobs/${id}/extract`);
  return response.data;
};

/**
 * Calculate match score
 */
export const calculateMatch = async (id, resumeId = null) => {
  const response = await api.post(`/jobs/${id}/match`, { resumeId });
  return response.data;
};

export default {
  getJobs,
  getJobStats,
  getJob,
  createJob,
  updateJob,
  deleteJob,
  extractJob,
  calculateMatch
};
